import { App } from 'antd';
import { antdMessage } from '../utils/global_message';

const MessageHolder = () => {
  const { message, notification, modal } = App.useApp();

  // Assign the instances to the exported object
  antdMessage.message = message;
  antdMessage.notification = notification;
  antdMessage.modal = modal;

  // This component doesn't render anything
  return null;
};

export default MessageHolder;